/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { appInsights } from '../lib/insights';

interface Props {
  children?: ReactNode;
}

export class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error | null, info: any) {
    if (error !== null) {
      appInsights?.trackException({ exception: error, properties: { info } });
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <h1>Something went wrong.</h1>
          <p>
            {`We've alerted our engineers to the problem and we'll track down the problem as soon as possible.`}
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
